import angular from 'angular'

import { ServiceWorkerManagerService as ServiceWorkerManager } from './service-worker-manager.service'

angular
  .module('webregister.components')
  .service('serviceWorkerManager', ServiceWorkerManager)
